import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

export function Header({ contactInfo }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { pathname } = useLocation();
  const history = useNavigate();

  const isHome = pathname === "/" || pathname.startsWith("/#");

  const handleSearch = () => {
    if (searchTerm.trim()) {
      history(`/search?query=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <>
      <div className="ann">
        <div className="container">
          <span className="badge">NEW</span>
          {contactInfo.ticker}
        </div>
      </div>

      <header>
        <div className="container nav" role="navigation" aria-label="Main">
          <button
            className="menu-btn pill"
            aria-controls="mobileMenu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((s) => !s)}
          >
            ☰ Menu
          </button>

          <a href="/" className="logo" aria-label="Patient Choice Home">
            <svg viewBox="0 0 48 48" aria-hidden="true" fill="none">
              <defs>
                <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stopColor="var(--brand-2)" />
                  <stop offset="1" stopColor="var(--brand)" />
                </linearGradient>
              </defs>
              <path
                d="M24 41s-9.5-6.9-15.3-12.7C4.6 24.2 5 16.6 10 13.2a8.5 8.5 0 0 1 10 .6l4 3.2 4-3.2a8.5 8.5 0 0 1 10-.6c5.1 3.4 5.4 11-.7 15.1C33.5 34.1 24 41 24 41Z"
                stroke="url(#g)"
                strokeWidth="2.5"
                fill="none"
              />
              <path d="M22.5 23h-4v-4h-3v4h-4v3h4v4h3v-4h4z" fill="url(#g)" />
            </svg>
            <span>PATIENT CHOICE</span>
          </a>

          {/* Search bar */}
          <div className="search" role="search" style={{ display: "flex", gap: "0.5rem" }}>
            <input
              id="q"
              type="search"
              value={searchTerm}
              placeholder="Search OTC meds, braces, wound care, glucose monitors…"
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                flex: 1,
                padding: "0.5rem 0.75rem",
                borderRadius: "9999px",
                border: "1px solid lightgray",
                minWidth: 100,
              }}
            />
            {searchTerm.trim() !== "" && (
              <button
                onClick={handleSearch}
                className="pill"
                style={{
                  padding: "0.5rem 1rem",
                  background: "var(--brand)",
                  color: "white",
                  borderRadius: "9999px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Search
              </button>
            )}
          </div>

          <nav className="nav-links" aria-label="Shop">
            {isHome && (
              <>
                <a className="pill" href="#categories">
                  Categories
                </a>
              </>
            )}
            <a className="pill" href="/eat4living">
              Liviq
            </a>
            {/* <a className="pill" href="/videos">
              Videos
            </a>
            <a className="pill" href="/education">
              Education
            </a> */}
            <a className="pill cta" href="/contact-us">
              Contact
            </a>
          </nav>
        </div>

        {/* Mobile menu */}
        <div
          id="mobileMenu"
          className={`mobile-menu container ${mobileOpen ? "show" : ""}`}
          aria-label="Mobile menu"
        >
          <div className="section" style={{ padding: "0rem 0 1.2rem", marginLeft: -10 }}>
            {/* {isHome && ( */}
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'space-between' }}>
              {isHome &&
                <a className="pill" href="#categories">
                  Categories
                </a>
              }
              <a className="pill" href="/eat4living">
                Liviq
              </a>
              {/* <a className="pill" href="/videos">
                Videos
              </a>
              <a className="pill" href="/education">
                Education
              </a> */}
              <a className="pill cta" href="/contact-us">
                Contact
              </a>
            </div>
            {/* )} */}
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
